const { REACT_APP_FIGMA_API_URL } = process.env;
export async function nodesQuery({ client, file, nodes }) {
  const url = new URL(`${REACT_APP_FIGMA_API_URL}/files/${file}/nodes`);
  url.searchParams.append('ids', nodes.join(','));
  const { data } = await client.post(`figma/query/`, {
    url,
  });
  return data;
}
